itsoftApp.createModule("scrollEffects", ["windowResize", "windowScroll"], function () {
    const module = this;
    // const viewWidthEl = document.querySelector(".js-viewport");
    // const desktopEl = document.querySelector(".js-desktop");

    // if (viewWidthEl || desktopEl) {
    //     let viewport = itsoftApp.utils.getViewportSize();

    //     itsoftApp.modules.windowResize.addEvent(function () {
    //         viewport = itsoftApp.utils.getViewportSize();
    //     });
    // }

    function ScrollEffect (self, classAnimate, oldClass) {
        this._target = self;
        this._classAnimate = classAnimate;
        this._oldClass = oldClass;
        this._scrollPoint;
        this._position = "bottom";

        if (this._target.hasAttribute("data-position")) {
            this._position = this._target.getAttribute("data-position");
        }
        this.init();
    }

    ScrollEffect.prototype.processing = false;

    ScrollEffect.prototype.calculateValue = function () { //cb
        if (this._position === "middle") {
            this._positionValue = window.innerHeight / 2;
        } else if (this._position === "top") {
            this._positionValue = 0;
        } else {
            this._positionValue = window.innerHeight;
        }

        return this._positionValue;
    };

    ScrollEffect.prototype.init = function () {
        const self = this;

        self._check = function () { //scroll
            const scrolled = pageYOffset;
            // var coeff;

            self._scrollPoint = parseInt(self._target.getBoundingClientRect().top);

            if (scrolled + self.calculateValue() >= self._scrollPoint + scrolled) { /* NOTE: Если равен 0, элемент, скорее всего, скрыт display: none*/
                self.start();
            }
        };

        module.scrollEffectElements.push(self);

        self._check();

        itsoftApp.modules.windowScroll.addEvent(self._check);
    };

    ScrollEffect.prototype.removeOldClass = function () {
        this._target.classList.remove(this._oldClass);
        if (this._classAnimate) {
            this._target.classList.add(this._classAnimate);
        }
        this._oldClass = undefined;
    };

    ScrollEffect.prototype.start = function () {
        if (!this._oldClass && this.processing) {
            return;
        }

        if (!this._target.classList.contains("js-invisible")) {
            return;
        }

        this.processing = true;

        /* Ленивая загрузка скриптов */

        if (this._target.classList.contains("js-slider")) {
            this.removeOldClass();
            let sliderSettingsKey = this._target.getAttribute("data-slider-settings"); // получаем data-атрибут
            const sliderSettingsObject = itsoftApp.modules.slidersSettings.getSettings(sliderSettingsKey); // получаем объект конфига

            if (sliderSettingsKey && sliderSettingsObject) {
                new itsoftApp.modules.slidersLibrary.callback(this._target, sliderSettingsObject);
            } else {
                new itsoftApp.modules.slidersLibrary.callback(this._target);
            }
        }

        if (this._target.classList.contains("js-accordion")) {
            this.removeOldClass();
            new itsoftApp.modules.accordion.callback(this._target);
        }

        if (this._target.classList.contains("js-tabs-section")) {
            this.removeOldClass();
            new itsoftApp.modules.toggleTabs.callback.init(this._target);
        }

        if (this._target.classList.contains("js-load-section")) {
            this.removeOldClass();
            itsoftApp.modules.loadItems.initLoad(this._target);
        }

        if (this._target.classList.contains("js-scroll-trigger") && !(this._target.classList.contains("js-anim-disable-target-active"))) {
            if (!(pageYOffset > pageYOffset + this._target.getBoundingClientRect().top)) {
                this.removeOldClass();
                itsoftApp.modules.scrollActions.callback(this._target, true, false);
            }
        }

        /* Ленивая загрузка шрифтов */
        if (this._target.classList.contains("page__fw-600")) {
            this.removeOldClass();
            body.classList.add("page--fw-600");
        }

        this.processing = false;
    };


    module.ScrollEffect = ScrollEffect;
    module.scrollEffectElements = [];
});
